export default "__VITE_ASSET__6XTzVf7g__"